export default "__VITE_ASSET__CUQnTBjI__"